import { serviceQueryKeys as e } from "./useServiceQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { servicesApi as r } from "@maat/api-main";
//#region src/services/useUpdateServiceMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ serviceId: e, data: t }) => r.updateService(e, t),
		onSuccess: (t, { serviceId: n }) => {
			i.invalidateQueries({ queryKey: e.list() }), i.invalidateQueries({ queryKey: e.detail(n) });
		}
	});
};
//#endregion
export { i as useUpdateServiceMutation };
